import { useEffect } from 'react';
import { useLocation } from 'react-router';

import i18n from '@/i18n';
import { isMarketingPath, stripLangPrefix } from '@/seo/marketing-routes';

import { useGetUserLanguage } from '../hooks/use-local-storage';

export const AVAILABLE_LANGUAGES_MAP_LONG_TO_SHORT = {
  English: 'en',
  Italian: 'it',
  Spanish: 'es',
  French: 'fr',
  German: 'de',
  Swedish: 'sv',
  Polish: 'pl',
  Hebrew: 'he',
  Catalan: 'ca',
};

export const LanguageChanger = () => {
  const { language } = useGetUserLanguage();
  const { pathname } = useLocation();
  // On public marketing routes the URL prefix (via LangBoundary) is the single
  // source of truth for language, so the stored-preference sync is suppressed
  // there to avoid the two fighting over `i18n.language`.
  const onMarketingRoute = isMarketingPath(stripLangPrefix(pathname));

  useEffect(() => {
    if (onMarketingRoute) {
      return;
    }

    if (
      i18n.language ===
      AVAILABLE_LANGUAGES_MAP_LONG_TO_SHORT[
        language as keyof typeof AVAILABLE_LANGUAGES_MAP_LONG_TO_SHORT
      ]
    ) {
      return;
    }

    if (language in AVAILABLE_LANGUAGES_MAP_LONG_TO_SHORT) {
      const shortLang =
        AVAILABLE_LANGUAGES_MAP_LONG_TO_SHORT[
          language as keyof typeof AVAILABLE_LANGUAGES_MAP_LONG_TO_SHORT
        ];
      i18n.changeLanguage(shortLang);

      return;
    }
  }, [language, onMarketingRoute]);

  return <></>;
};
